import axios from 'axios'
import { toolkitUrls } from '@/links'

export async function getAnchorPageForEditing(gradeLevelUUID) {
  let url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}?with_access_points=1&prefer_draft=1`
  try {
    let resp = await axios.get(url,{withCredentials: true})
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function checkAnchorPageForDraft(gradeLevelUUID) {
  let url = `${toolkitUrls.api}/anchor-access-points/draft/${gradeLevelUUID}`
  try {
    let resp = await axios.get(url, {withCredentials: true})
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function publishDraftForAnchorPage(gradeLevelUUID) {
  let url = `${toolkitUrls.api}/anchor-access-points/overwrite-draft/${gradeLevelUUID}`
  try {
    let resp = await axios.put(
      url,
      {},
      {
        withCredentials: true
      }
    )
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function deleteDraftForAnchorPage(gradeLevelUUID) {
  let url = `${toolkitUrls.api}/anchor-access-points/draft/${gradeLevelUUID}`
  try {
    let resp = await axios.delete(
      url,
      {
        withCredentials: true
      }
    )
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function create(title) {
  let url = `${toolkitUrls.api}/anchor-access-points`
  try {
    let resp = await axios.post(
      url,
      { title },
      {
        withCredentials: true
      }
    )
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function generateAccessPoints(gradeLevelUUID) {
  let url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}`
  try {
    let resp = await axios.post(
      url,
      {},
      {
        withCredentials: true
      }
    )
    return resp.data
  } catch (err) {
    throw err.toJSON()
  }
}

export async function update({ gradeLevelUUID, uuidsToUpdate, updates }) {
  let url = `${toolkitUrls.api}/anchor-access-points/${gradeLevelUUID}`
  try {
    let resp = await axios.put(
      url,
      {
        uuids: uuidsToUpdate,
        updates
      },
      {
        withCredentials: true
      }
    )
    return resp.data
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data)
    } else if (err.request) {
      throw new Error(err.request)
    } else {
      throw err
    }
  }
}
